import { type RouteObject } from "react-router-dom";

import { AUTH_ROLES } from "api/common/types/auth.types";
import DeleteMailListModal from "features/memberPortal/mail/components/MailList/components/DeleteMailListModal/DeleteMailList.modal";
import MailListModal from "features/memberPortal/mail/components/MailList/MailList.modal";
import MailListCategories from "features/memberPortal/mail/components/MailListCategories/MailListCategories.modal";
import AddMember from "features/memberPortal/mail/components/MailListDetails/components/AddMemberModal/AddMember.modal";
import MailListDetails from "features/memberPortal/mail/components/MailListDetails/MailListDetails.screen";
import CreateMember from "features/memberPortal/mail/components/MailListMembers/components/MailListCreateMember/CreateNewMember.modal";
import MailListMembersScreen from "features/memberPortal/mail/components/MailListMembers/MailListMembers.screen";
import MailList from "features/memberPortal/mail/MailList.screen";
import AuthenticatedRoute from "routing/AuthenticatedRoute";

const { NIAP } = AUTH_ROLES;

const mailListRoutes: RouteObject[] = [
  {
    path: "mailing-lists",
    element: <AuthenticatedRoute allowedRoles={[NIAP]} />,
    children: [
      {
        path: "",
        element: <MailList />,
        children: [
          {
            path: "add",
            element: <MailListModal />,
          },
          {
            path: "categories",
            element: <MailListCategories />,
          },
          {
            path: "delete/:id",
            element: <DeleteMailListModal />,
          },
        ],
      },
      {
        path: "details/:id",
        element: <MailListDetails />,
        children: [
          {
            path: "add",
            element: <AddMember />,
          },
          {
            path: "delete/:id",
            element: <DeleteMailListModal />,
          },
        ],
      },
      {
        path: "members",
        element: <MailListMembersScreen />,
        children: [
          {
            path: "add",
            element: <CreateMember />,
          },
        ],
      },
    ],
  },
];

export default mailListRoutes;
